<app-header-basic *ngIf="headerType == HeaderType.Basic || headerType == HeaderType.Login" [headerType]="headerType"
    [headerStyles]="headerStyles" [showClassVerify]="showClassVerify"
    [brandResources]="brandResources"></app-header-basic>

<app-header-pci *ngIf="headerType == HeaderType.Pci" [brandResources]="brandResources" [FunnelFlow]="FunnelFlow" [showClassVerify]="showClassVerify"></app-header-pci>

<app-header-funnels-and-member-portal *ngIf="headerType == HeaderType.Funnels || headerType == HeaderType.MemberPortal"
    [FunnelFlow]="FunnelFlow" [headerType]="headerType" [headerStyles]="headerStyles"
    [showClassVerify]="showClassVerify" [RedirectWithLogo]="RedirectWithLogo"
    [ShowMenuMobile]="ShowMenuMobile"></app-header-funnels-and-member-portal>

<app-header-finsights *ngIf="headerType == HeaderType.MemberPortalFinsights" [FunnelFlow]="FunnelFlow" [headerType]="headerType" [ShowMenuMobile]="ShowMenuMobile"></app-header-finsights>

<app-header-secondary-brand *ngIf="headerType == HeaderType.SecondaryBrand" [FunnelFlow]="FunnelFlow"
    [showClassVerify]="showClassVerify" [brandResources]="brandResources" [headerStyles]="headerStyles"></app-header-secondary-brand>

<app-header-countdown *ngIf="headerType == HeaderType.Countdown" [brandResources]="brandResources"></app-header-countdown>

<app-header-1087 *ngIf="headerType == HeaderType.Header1087" [brandResources]="brandResources" [FunnelFlow]="FunnelFlow"></app-header-1087>